module.exports = __webpack_public_path__ + "img/auto_checkin.680f0d2a.png";